export default __webpack_public_path__ + "static/media/BZ.47e6ffe7.svg";